import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import { apiService } from '../../services/api'
import { useBranding } from '../../context/BrandingContext'
import '../../styles/client-pages.css'

// ── Inline SVG icons ──────────────────────────────────────────────────────────
const IcSearch  = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
const IcRocket  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>
const IcEdit    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
const IcDomain  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
const IcCard    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
const IcFile    = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
const IcArrow   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
const IcSend    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
const IcMsg     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
const IcHelp    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
const IcChevron = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
const IcBack    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
const IcCheck   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>

// ── Seed wiki content ─────────────────────────────────────────────────────────
// NOTE: static for now — structured to swap to the admin-managed backend later.
const CATEGORIES = [
  { id: 'getting-started', title: 'Getting started',  icon: <IcRocket /> },
  { id: 'editing',         title: 'Editing your site', icon: <IcEdit /> },
  { id: 'domain',          title: 'Domain & email',    icon: <IcDomain /> },
  { id: 'billing',         title: 'Billing & plans',   icon: <IcCard /> },
]
const CAT_TITLE = Object.fromEntries(CATEGORIES.map(c => [c.id, c.title]))

const ARTICLES = [
  {
    id: 'gs-dashboard', cat: 'getting-started', title: 'Getting started with your dashboard', read: '2 min',
    body: [
      'Your dashboard is home base. From the left menu you can jump to your site, send change requests, view analytics, manage your domain and handle billing.',
      'Everything updates in real time — when your team publishes a change, you\'ll see it reflected here straight away.',
    ],
  },
  {
    id: 'gs-trial', cat: 'getting-started', title: 'What happens during my free trial', read: '2 min', popular: true,
    body: [
      'During your trial you have full access to build and preview your site. Nothing is charged until you choose a paid plan.',
      'When you\'re ready, head to Billing to pick a plan — your work carries over exactly as-is.',
    ],
  },
  {
    id: 'gs-analytics', cat: 'getting-started', title: 'Understanding your visitor analytics', read: '3 min', popular: true,
    body: [
      'The Analytics page shows who\'s visiting your site, where they come from, what devices they use and which pages are most popular.',
      'Use the date-range buttons to switch between the last 7, 30 or 90 days. "How people find you" breaks visitors down by search engine and social network.',
    ],
  },
  {
    id: 'edit-text-images', cat: 'editing', title: 'How to change text and images on your site', read: '3 min', popular: true,
    body: [
      'Open the editor from the sidebar, then click any text or image directly to change it. Edits save as you go.',
      'Prefer we handle it? Send a request from the Requests page describing what you\'d like changed and your team will take care of it — usually within a few hours.',
    ],
  },
  {
    id: 'edit-pages', cat: 'editing', title: 'Adding, removing and reordering pages', read: '4 min', popular: true,
    body: [
      'In the editor, use the Pages panel to add a new page, rename it, or drag to reorder how pages appear in your navigation.',
      'Removing a page is permanent once published, so we\'ll always ask you to confirm first.',
    ],
  },
  {
    id: 'edit-contact-form', cat: 'editing', title: 'Setting up a contact form', read: '3 min', popular: true,
    body: [
      'Add a contact form block to any page and choose where submissions should be emailed.',
      'Submissions are delivered straight to your inbox — no extra setup needed.',
    ],
  },
  {
    id: 'edit-publish', cat: 'editing', title: 'Publishing your changes', read: '2 min',
    body: [
      'Changes you make in the editor stay in draft until you publish. Hit Publish to push them live to your domain.',
      'Most changes appear instantly; occasionally it can take a minute or two to update everywhere.',
    ],
  },
  {
    id: 'domain-connect', cat: 'domain', title: 'Connecting a domain you already own', read: '5 min', popular: true,
    body: [
      'Go to the Domain page and choose "Connect another domain". Add the DNS records shown at your registrar (GoDaddy, Namecheap, Cloudflare, etc.).',
      'Then click "Check connection" — we verify the records against your nameservers and switch your site over automatically once they\'re live. DNS can take up to 24 hours to propagate.',
    ],
  },
  {
    id: 'domain-default', cat: 'domain', title: 'Setting your default domain', read: '2 min',
    body: [
      'If you have more than one domain connected, open the Domain page and choose "Make default" on the one you want as your main address.',
      'Visitors arriving on any other domain are automatically redirected to your default, so you have a single canonical web address.',
    ],
  },
  {
    id: 'billing-plan', cat: 'billing', title: 'Understanding your plan and usage', read: '3 min',
    body: [
      'The Billing page shows your current plan, what you\'ve used this month (sites, edit requests and storage) and your next charge.',
      'You can compare plans and switch any time — changes are prorated automatically.',
    ],
  },
  {
    id: 'billing-payment', cat: 'billing', title: 'Updating your payment method', read: '2 min',
    body: [
      'On the Billing page, use "Update card" to open the secure payment portal where you can change your card or download past invoices.',
      'All payments are handled by Stripe — we never store your full card details.',
    ],
  },
]

const POPULAR = ARTICLES.filter(a => a.popular)

const FAQS = [
  { q: 'How do I request a change to my site?', a: 'Head to the Requests page and click "New request". Describe what you\'d like changed — you can attach images or files too. Your team typically replies within a few hours and handles the edit for you.' },
  { q: 'Can I edit the website myself?', a: 'Yes! Open the editor from the sidebar. You can change text and images directly by clicking on them. Anything you\'re unsure about, just send us a request instead.' },
  { q: 'When will my changes go live?', a: 'Most edits are published the same day. You\'ll see a status on each request — Open, In progress, then Done — and get a message from your team when it\'s live.' },
  { q: 'How do I add a custom email address?', a: 'Go to the Domain page to connect your domain, then point an email address at your inbox with your email provider of choice.' },
  { q: 'How do I change my plan or payment method?', a: 'Everything billing-related lives on the Billing page. You can compare plans, upgrade or downgrade (changes are prorated), and update your card there.' },
]

const STATUS_SERVICES = ['Website hosting', 'Visual editor', 'Analytics']

const matchesQuery = (a, q) => {
  const s = q.toLowerCase()
  return a.title.toLowerCase().includes(s) || a.body.join(' ').toLowerCase().includes(s)
}

// ── Article reader ────────────────────────────────────────────────────────────
function ArticleReader({ article, onBack }) {
  return (
    <>
      <div className="page-header">
        <div className="page-title">
          <button className="btn btn-sm" style={{ alignSelf: 'flex-start', marginBottom: 10 }} onClick={onBack}><IcBack /> All articles</button>
          <div className="eyebrow">{CAT_TITLE[article.cat]}</div>
          <h1>{article.title}</h1>
          <div className="subtitle">{article.read} read</div>
        </div>
      </div>
      <div className="page-body" style={{ gap: 18 }}>
        <div className="card card-pad" style={{ maxWidth: 760 }}>
          {article.body.map((p, i) => (
            <p key={i} style={{ fontSize: 14, color: 'var(--text-soft)', lineHeight: 1.7, margin: i === 0 ? '0 0 14px' : '0 0 14px' }}>{p}</p>
          ))}
          <div className="divider" style={{ margin: '18px 0' }} />
          <div className="flex items-center justify-between" style={{ gap: 12, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>Still need a hand?</span>
            <Link to="/client/requests" style={{ textDecoration: 'none' }}>
              <button className="btn btn-primary btn-sm"><IcMsg /> Message your team</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

// ── Main: wiki help center ──────────────────────────────────────────────────────
const ClientSupport = () => {
  const { cmsName, supportEmail } = useBranding()
  const [query, setQuery]         = useState('')
  const [activeCat, setActiveCat] = useState(null)
  const [openFaq, setOpenFaq]     = useState(0)
  const [article, setArticle]     = useState(null)

  const { data: profile } = useQuery('client-profile', () => apiService.get('/clients/profile').then(r => r.data), { staleTime: 5 * 60 * 1000 })
  const firstName = (profile?.user_name || '').trim().split(' ')[0]

  if (article) return <ArticleReader article={article} onBack={() => setArticle(null)} />

  const filtering = Boolean(query) || Boolean(activeCat)
  const listArticles = filtering
    ? ARTICLES.filter(a => (!activeCat || a.cat === activeCat) && (!query || matchesQuery(a, query)))
    : POPULAR
  const listTitle = query ? 'Search results' : activeCat ? CAT_TITLE[activeCat] : 'Popular articles'
  const faqs = query ? FAQS.filter(f => `${f.q} ${f.a}`.toLowerCase().includes(query.toLowerCase())) : FAQS
  const countFor = (id) => ARTICLES.filter(a => a.cat === id).length

  return (
    <>
      {/* Header */}
      <div className="page-header">
        <div className="page-title">
          <div className="eyebrow">Your account</div>
          <h1>Help &amp; support</h1>
          <div className="subtitle">Answers, guides, and a direct line to your team.</div>
        </div>
        <div className="flex gap-2 items-center">
          <Link to="/client/requests" style={{ textDecoration: 'none' }}>
            <button className="btn btn-primary"><IcMsg /> Message your team</button>
          </Link>
        </div>
      </div>

      <div className="page-body" style={{ gap: 18 }}>
        {/* Search hero */}
        <div className="help-search-wrap" style={{ maxWidth: 'none', margin: 0 }}>
          <div style={{ fontSize: 20, fontWeight: 600, letterSpacing: '-0.02em', marginBottom: 14 }}>
            How can we help{firstName ? `, ${firstName}` : ''}?
          </div>
          <div className="help-search">
            <IcSearch />
            <input
              placeholder='Search articles — e.g. "change my logo"'
              value={query}
              onChange={e => { setQuery(e.target.value); setActiveCat(null) }}
            />
            {query
              ? <button className="btn btn-sm btn-icon" onClick={() => setQuery('')} title="Clear">✕</button>
              : <span className="kbd">↵</span>}
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 14, flexWrap: 'wrap' }}>
            {['Editing text', 'Adding a page', 'Custom domain', 'Billing', 'Analytics'].map(t => (
              <button key={t} className="btn btn-sm" onClick={() => { setQuery(t); setActiveCat(null) }}>{t}</button>
            ))}
          </div>
          <div style={{ position: 'absolute', right: -40, bottom: -60, width: 200, height: 200, borderRadius: '50%', background: 'var(--accent-soft)', pointerEvents: 'none', filter: 'blur(50px)' }} />
        </div>

        {/* Categories */}
        <div className="bento" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: 14 }}>
          {CATEGORIES.map(c => {
            const active = activeCat === c.id
            return (
              <div
                key={c.id}
                className="help-cat"
                style={active ? { borderColor: 'var(--border-accent)', background: 'var(--accent-soft)' } : undefined}
                onClick={() => { setActiveCat(active ? null : c.id); setQuery('') }}
              >
                <span className="icon-tile" style={{ width: 36, height: 36, fontSize: 16 }}>{c.icon}</span>
                <div style={{ fontSize: 14, fontWeight: 600, marginTop: 2 }}>{c.title}</div>
                <div style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{countFor(c.id)} article{countFor(c.id) === 1 ? '' : 's'}</div>
              </div>
            )
          })}
        </div>

        <div className="bento" style={{ gridTemplateColumns: '1.5fr 1fr', gap: 14, alignItems: 'flex-start' }}>
          {/* Articles */}
          <div className="card card-pad">
            <div className="flex items-center justify-between" style={{ marginBottom: 12, gap: 10 }}>
              <h2 className="h2">{listTitle}</h2>
              {filtering && <button className="btn btn-sm" onClick={() => { setQuery(''); setActiveCat(null) }}>Clear</button>}
            </div>
            {listArticles.length === 0 ? (
              <div style={{ padding: '24px 0', textAlign: 'center', color: 'var(--text-faint)', fontSize: 12.5 }}>
                No articles found{query ? ` for “${query}”` : ''}. Try a different search, or message your team.
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {listArticles.map(a => (
                  <button key={a.id} className="help-article" onClick={() => setArticle(a)}>
                    <span className="icon-tile" style={{ width: 28, height: 28, fontSize: 13 }}><IcFile /></span>
                    <span style={{ flex: 1, fontSize: 13, color: 'var(--text)' }}>{a.title}</span>
                    <span style={{ color: 'var(--text-muted)', display: 'inline-flex' }}><IcArrow /></span>
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Contact + status */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div className="card card-pad">
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <div className="avatar-stack">
                  <div className="avatar avatar-grad-1">SV</div>
                  <div className="avatar avatar-grad-5">TL</div>
                  <div className="avatar avatar-grad-3">RP</div>
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.3 }}>Your {cmsName} team</div>
                  <div style={{ fontSize: 11.5, color: 'var(--success)', marginTop: 2 }}>● Online · replies in ~1 hour</div>
                </div>
              </div>
              <div style={{ fontSize: 12.5, color: 'var(--text-soft)', lineHeight: 1.55 }}>
                The same people who built your site. Send a message and a real human gets back to you.
              </div>
              <Link to="/client/requests" style={{ textDecoration: 'none', display: 'block' }}>
                <button className="btn btn-primary" style={{ width: '100%', marginTop: 14 }}><IcSend /> Start a conversation</button>
              </Link>
              {supportEmail && (
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 10, textAlign: 'center' }}>
                  or email <a href={`mailto:${supportEmail}`} style={{ color: 'var(--accent-3)', textDecoration: 'none' }}>{supportEmail}</a>
                </div>
              )}
            </div>

            <div className="card card-pad">
              <div className="flex items-center justify-between">
                <h2 className="h2">System status</h2>
                <span className="badge badge-success"><span className="badge-dot" /> Operational</span>
              </div>
              <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
                {STATUS_SERVICES.map(s => (
                  <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5 }}>
                    <span className="dot-live" />
                    <span style={{ color: 'var(--text-soft)', flex: 1 }}>{s}</span>
                    <span style={{ color: 'var(--text-muted)', fontSize: 11.5 }}>Operational</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="card card-pad">
          <h2 className="h2" style={{ marginBottom: 6 }}>Frequently asked</h2>
          {faqs.length === 0 ? (
            <div style={{ padding: '16px 0', color: 'var(--text-faint)', fontSize: 12.5 }}>No matching questions.</div>
          ) : faqs.map((f, i) => (
            <div key={i} className="faq-item" style={{ border: 'none', borderRadius: 0, marginBottom: 0, overflow: 'visible', borderBottom: '1px solid var(--border)' }}>
              <button className={`faq-q ${openFaq === i ? 'open' : ''}`} onClick={() => setOpenFaq(openFaq === i ? -1 : i)}>
                <span style={{ color: 'var(--accent-3)', display: 'inline-flex' }}><IcHelp /></span>
                {f.q}
                <span className="chev"><IcChevron /></span>
              </button>
              {openFaq === i && <div className="faq-a">{f.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default ClientSupport
